import { mergeOverrides } from 'baseui';
import { PhoneInputNext, StyledFlag } from 'baseui/phone-input';
import React from 'react';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { overrides as customOverrides } from './overrides';
import { IDummyProps } from './types';
import * as meta from '../../meta-data.json';
import { useStyletron } from 'styletron-react';
import { MIcon } from '../Icon';

/**
 * Used to use the expected ref - to be removed when we update baseui library
 * @param refs
 */
function useCombinedRefs(...refs: any) {
	const targetRef = React.useRef(null);

	React.useEffect(() => {
		refs.forEach((ref: any) => {
			if (!ref) return;
			if (typeof ref === 'function') {
				ref(targetRef.current);
			} else {
				ref.current = targetRef.current;
			}
		});
	}, [refs]);

	return targetRef;
}

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const HTMLAttrs = getHTMLAttributes(props);
	const { overrides, withFlag, ...rest } = props;
	let InputOverrides = { ...overrides?.Input };
	const [css] = useStyletron();
	const mountNodeRef = React.useRef<HTMLSpanElement>(null);
	const innerRef = ref?.current;
	const combinedRef = useCombinedRefs(ref, innerRef);
	const flagOverrides = {
		FlagContainer: {
			component: CustomFlag,
		},
	};

	const localOverrides = customOverrides(
		rest,
		css,
		mountNodeRef,
		combinedRef,
		HTMLAttrs.dataProps,
		HTMLAttrs.ariaProps,
		HTMLAttrs.rest,
		InputOverrides,
		withFlag ? flagOverrides : null,
	) as any;
	const _iconSize =
		props.size === 'large' ? 'var(--epods--button-large-icon-size)' : 'var(--epods--button-default-icon-size)';

	return (
		<div data-epo={`epo-phone-input-${meta.version}`}>
			<PhoneInputNext
				inputRef={combinedRef}
				startEnhancer={
					props.iconBefore ? <MIcon icon={props.iconBefore} size={_iconSize} /> : props.startEnhancer
				}
				endEnhancer={props.iconAfter ? <MIcon icon={props.iconAfter} size={_iconSize} /> : props.endEnhancer}
				overrides={overrides ? mergeOverrides(localOverrides, overrides as any) : localOverrides}
				{...rest}
			/>
			<span ref={mountNodeRef}></span>
		</div>
	);
});

const CustomFlag = (props: any) => {
	const { children, ...rest } = props;
	return <StyledFlag iso={props.$iso} {...rest} data-testid="phone-input-flag" />;
};
